import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const isChunkError = /Loading chunk [\w-]+ failed/i.test(error?.message ?? '');
    if (isChunkError) {
      console.error(error?.message ?? '');
      window.location.reload();
    } else {
      console.error(error);
    }
  }
}
